<div>
  <header>
    <button class="back unstyled-button" onclick="history.back()"><mat-icon svgIcon="left_arrow"></mat-icon><span>Tilbage</span></button>
    <h1 #title>{{ basketTitle }}</h1>
  </header>

  @if (showProductErrors) {
    <div class="basket-error">
      <h3><mat-icon svgIcon="warning"></mat-icon>{{ errorMessage.title }}</h3>
      <p>{{ errorMessage.message }}</p>
    </div>
    <app-text-button class="basket-error-button" (click)="removeInvalidBasket()">{{ errorMessage.button }}</app-text-button>
  }

  @let productLines = productLines$ | async;
  <ul class="basket-items unstyled">
    @for (productLine of productLines; track productLine.lineId) {
      <li>
        <app-meny-basket-item
          [product]="productLine.product"
          [quantity]="productLine.quantity"
          [error]="showProductErrors && productLine.error"
          (callback)="showProductErrors && validateBasket()"
        ></app-meny-basket-item>
      </li>
    }
  </ul>
  <div class="discount-price-wrapper">
    @let prices =
      {
        total: totalPrice$ | async,
        shipping: (shipping$ | async)?.price || 0,
        products: linesTotalPrice$ | async,
        packaging: (packagingPrice$ | async) || 0,
        discount: (discount$ | async) || 0,
      };
    <div class="total-price">
      <span class="prices">
        <span>{{ totalProductsPriceLabel }}</span>
        <span>{{ prices.products | number: '.2-2' : locale }} {{ currency | displayCurrency }}</span>
      </span>
      <span class="prices">
        <span>{{ packagingPriceLabel }}</span>
        @if (prices.packaging) {
          <span>{{ prices.packaging | number: '.2-2' : locale }} {{ currency | displayCurrency }}</span>
        }
        @if (!prices.packaging) {
          <span>Gratis</span>
        }
      </span>
      <span class="prices">
        @let shippingInfo = shippingInfo$ | async;
        @if (shippingInfo?.isDelivery && shippingPriceDeliveryLabel) {
          <span>{{ shippingPriceDeliveryLabel }}</span>
        } @else {
          <span>{{ shippingPriceLabel }}</span>
        }
        @if (prices.shipping) {
          <span>{{ prices.shipping | number: '.2-2' : locale }} {{ currency | displayCurrency }}</span>
        }
        @if (!prices.shipping) {
          <span>Gratis</span>
        }
      </span>
      @if (prices.discount !== 0) {
        <span class="prices discount">
          <span>{{ discountPriceLabel }}</span>
          <span>{{ prices.discount | number: '.2-2' : locale }} {{ currency | displayCurrency }}</span>
        </span>
      }
      <span class="prices">
        <b>{{ totalPriceLabel }}</b>
        <b>{{ prices.total | number: '.2-2' : locale }} {{ currency | displayCurrency }}</b>
      </span>
      <span class="tax">
        (heraf moms {{ calculateTax(prices.products, prices.shipping, prices.packaging, prices.discount) | number: '.2-2' : locale }}
        {{ currency | displayCurrency }})
      </span>
    </div>
    @if (promotionForm?.controls.promotionCode; as control) {
      <form [formGroup]="promotionForm" (ngSubmit)="submitDiscount()">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ promotionCodePlaceholder }}</mat-label>
          <input matInput type="text" [placeholder]="promotionCodePlaceholder" [formControl]="control" />
        </mat-form-field>
        <button class="unstyled-button">{{ promotionCodeButton }}</button>
      </form>
    }
  </div>

  @let shippingValid = shippingValid$ | async;
  <button class="unstyled-button shipping-select" (click)="openShippingDialog()" [disabled]="useKioskShipping" tabindex="0">
    @if (!shippingValid) {
      <span class="no-shipping-selected">
        <mat-icon svgIcon="shop"></mat-icon>
        {{ shippingPickupPriceLabel }}
      </span>
      <span class="no-shipping-selected">{{ shippingPickupButton }}</span>
    }
    @if (shippingValid) {
      <span>
        <mat-icon svgIcon="shop"></mat-icon>
        {{ shippingName }}
      </span>
      @let shipping = shipping$ | async;
      <span>
        {{ isMobile ? (shipping.date.toJSDate() | date: 'shortDate') : (shipping.date.toJSDate() | date: 'fullDate') }}
        {{ shipping?.time?.period }}
      </span>
    }
  </button>

  @if (!useAgeVerification && containsAlcohol$ | async) {
    <div class="age-restricted">
      <div>
        <label for="age-restricted">{{ ageRestrictedLabel }}<span>*</span></label>
        <app-toggle id="age-restricted" [control]="form?.controls?.legalAgeConsent"></app-toggle>
      </div>
      <img
        src="assets/images/sundhedsstyrelsen.png"
        alt="Aldersgrænse for salg: 16 år for alkohol under 16,5% og 18 år for alkohol fra 16,5%"
      />
    </div>
  }

  <div class="buttons">
    <button class="emptyBasket unstyled-button" (click)="resetBasket()">Tøm kurv</button>
    <app-text-button (click)="checkout()" [disabled]="!isValidState || storeClosed">{{ checkoutButton }}</app-text-button>
  </div>

  <!-- Extra tilvalg -->
  @let productAdditions = getProductAdditions(productLines$ | async);
  @if (productAdditions.display) {
    <app-product-additions [additions]="productAdditions"></app-product-additions>
  }

  @if (contactInformation && !isKiosk) {
    <div class="contact">
      <label for="contact-information" tabindex="0">{{ contactInformation }}</label>
      @if (contactPhoneNumber) {
        <a class="contact-number unstyled-link" [href]="'tel:' + contactPhoneNumber">
          <mat-icon svgIcon="contact"></mat-icon> {{ contactPhoneNumber }}
        </a>
      }
    </div>
  }
</div>
